import { useCallback, useEffect, useState, useMemo } from 'react';
import {
  Box,
  FormControl,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import Button from '@material-ui/core/Button';
import { useLocation, useIntl, history } from 'umi';
import { useDispatch, useSelector } from 'dva';
import Fab from '@material-ui/core/Fab';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Controller, useForm } from 'react-hook-form';
import AddIcon from '@material-ui/icons/Add';
import ModalML from '@/components/ModalML';

import { AddTemplateStyled, ModalStyled } from './AddTemplateStyled';

const AddTemplate = () => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { control, setValue, errors, handleSubmit } = useForm({});
  const location = useLocation();
  const { query } = location;
  const { id, opt } = query;
  // 关于外部框的的一些
  const [fixedParam, setFixedParam] = useState({
    title: '',
    type: '',
    // url: '',
    miniProgram: { pagepath: '', appid: '' },
    data: {
      first: { value: '' },
      remark: { value: '' },
    },
  });
  //右侧展示内容
  const [content, setContent] = useState('');
  const [contentData, setContentData] = useState();
  //弹框选字段
  const [keyField, setKeyField] = useState();
  //修改框的name 关于选字段和颜色逻辑
  const [inputName, setInputName] = useState();
  const [inputValue, setInputValue] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [openColorModal, setOpenColorModal] = useState(false);

  //拿取详情
  //模板消息详情（编辑情况）
  const templateMessageDetail = useSelector(
    (state) => state.addWmpTemplate.templateMessageDetail,
  );
  //模板消息详情（新增情况）
  const templateDetail = useSelector(
    (state) => state.addWmpTemplate.templateDetail,
  );
  //可提供微信字段列表
  const tempMsgVariableList = useSelector(
    (state) => state.addWmpTemplate.tempMsgVariableList,
  );
  //appid列表
  // const appIdList = useSelector((state) => state.addWmpTemplate.appIdList) || [];
  //动态展示列表
  const dynamicObj =
    opt === 'add' ? templateDetail?.data : templateMessageDetail?.data;
  const contentMap =
    opt === 'add'
      ? templateDetail?.contentMap
      : templateMessageDetail?.contentMap;
  const keyWorldList = useMemo(() => {
    const obj = { ...dynamicObj };
    let array = [];
    if (dynamicObj) {
      setInputValue(obj);
      const keyNameList = Object.keys(obj);
      array = keyNameList.map((i) => {
        return { [i]: obj[i] };
      });
      const hasRemark = keyNameList?.some((i) => i === 'remark');
      if (hasRemark) {
        let i;
        array.map((item, index) => {
          if (Object.keys(item)[0] === 'remark') {
            i = index;
          }
        });
        array.splice(i, 1);
        const remark = dynamicObj?.remark;
        return [...array, { remark }];
      }
      return array;
    }
    return [];
  }, [dynamicObj]);

  const dispatch = useDispatch();
  //新增的时候的详情
  const fetchAddTemplateDetail = useCallback(() => {
    dispatch({
      type: 'addWmpTemplate/getTemplateDetail',
      payload: { values: { id: Number(id) } },
      callback: () => {},
    });
  }, [dispatch, id]);
  //编辑时的详情
  const fetchAddTemplateMessageDetail = useCallback(() => {
    dispatch({
      type: 'addWmpTemplate/getTemplateMessageDetail',
      payload: { values: { id: Number(id) } },
      callback: () => {},
    });
  }, [dispatch, id]);

  const fetchTempMsgVariableList = useCallback(() => {
    dispatch({
      type: 'addWmpTemplate/getTempMsgVariableList',
      payload: {
        values: {},
      },
      callback: () => {},
    });
  }, [dispatch]);

  //编辑时候拿到的值给表单赋值
  useEffect(() => {
    if (opt === 'edit' && templateMessageDetail) {
      // let url = templateMessageDetail.url;
      let pagePath = templateMessageDetail.page;
      let appid = templateMessageDetail.miniProgram?.appid;
      setValue('title', templateMessageDetail.title);
      setValue('type', templateMessageDetail.type);
      // setValue('url', templateMessageDetail?.url);
      setFixedParam({
        ...templateMessageDetail,
        // url: url ? url : '',
        miniProgram: {
          pagepath: pagePath ? pagePath : '',
          appid: appid ? appid : '',
        },
      });
      setContentData(templateMessageDetail.content);
      setContent(templateMessageDetail.content);
    }
    if (opt === 'add' && templateDetail) {
      setFixedParam({
        ...templateDetail,
        miniProgram: { pagepath: '', appid: '' },
        // url: '',
      });
      setContent(templateDetail.content);
      setContentData(templateDetail.content);
    }
  }, [opt, templateDetail, templateMessageDetail, setValue]);
  useEffect(() => {
    if (opt === 'add') {
      fetchAddTemplateDetail();
    } else if (opt === 'edit') {
      fetchAddTemplateMessageDetail();
    }
  }, [fetchAddTemplateDetail, fetchAddTemplateMessageDetail, opt]);

  useEffect(() => {
    fetchTempMsgVariableList();
  }, [fetchTempMsgVariableList]);

  //关于处理内容的
  useEffect(() => {
    if (content) {
      let newContent = contentData;
      keyWorldList.map((i) => {
        const key = Object.keys(i)[0];
        const keyName = key;
        newContent = newContent.replace(
          `{{${keyName}}}`,
          `<span style='color:#4F4F4F; font-weight:600;margin-left:12px'>${inputValue[key]?.value}</span>`,
        );
        // setContent(x);
      });
      newContent = newContent?.replaceAll('\n', '<br/>');
      setContent(newContent);
    }
  }, [content, keyWorldList, inputValue, contentData]);

  //提交事件
  const handleSubmitData = () => {
    let values = { ...fixedParam };
    values.data = { ...fixedParam.data, ...inputValue };
    console.log(values);
    if (opt === 'add') {
      dispatch({
        type: 'addWmpTemplate/addTemplate',
        payload: {
          values: {
            ...values,
            tempId: id,
            page: values.miniProgram.pagepath,
            type: 'all',
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '新增成功',
              title: '成功',
            });
          }
          dispatch({
            type: 'addWmpTemplate/save',
            payload: { templateDetail: {} },
          });
          history.push({
            pathname: '/miniapps/template_list',
            query: { tab: '2' },
          });
        },
      });
    } else if (opt === 'edit') {
      dispatch({
        type: 'addWmpTemplate/updateTemplate',
        payload: {
          values: { ...values, page: values.miniProgram.pagepath, type: 'all' },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '修改成功',
              title: '成功',
            });
          }
          dispatch({
            type: 'addWmpTemplate/save',
            payload: { templateMessageDetail: {} },
          });
          history.goBack();
        },
      });
    }
  };

  //处理拿到的content
  const handleOpenModal = () => {
    setOpenModal(true);
    setKeyField();
  };
  const handleSubmitFaild = () => {};
  return (
    <form onSubmit={handleSubmit(handleSubmitData, handleSubmitFaild)}>
      <AddTemplateStyled>
        <Box className="add-wrapper">
          <Box className="first-row">
            <Box className="campaign-name">
              <Controller
                rules={{
                  required: true,
                  validate: (e) => {
                    const value = e.trim();
                    return Boolean(value);
                  },
                }}
                error={Boolean(errors.title)}
                render={(rp) => (
                  <TextField
                    name="title"
                    rules={{
                      required: true,
                    }}
                    error={Boolean(errors.title)}
                    variant="standard"
                    label={
                      <>
                        <span className="label-require">*</span>
                        <span className="label-name">订阅消息名称</span>
                      </>
                    }
                    value={rp.value ?? fixedParam.title}
                    // defaultValue={opt === 'edit' ? templateMessageDetail.title : ''}
                    onChange={(e) => {
                      setValue('title', e.target.value);
                      setFixedParam({ ...fixedParam, title: e.target.value });
                      return rp.value;
                    }}
                  />
                )}
                name="title"
                control={control}
                id="basic"
                className="input"
              />
              <FormHelperText error={Boolean(errors.title)}>
                {errors.title?.type === 'required' &&
                  formatMessage({ id: 'wechat.official.add.n02.txt01' })}
                {errors.title?.type === 'validate' &&
                  formatMessage({ id: 'wechat.official.add.n02.txt02' })}
              </FormHelperText>
            </Box>
            <Box></Box>
          </Box>
          {keyWorldList?.length > 0 &&
            keyWorldList.map((item) => {
              const key = Object.keys(item)[0];
              const currentNewValue = inputValue[key];
              currentNewValue && setValue(key, currentNewValue.value);
              let multiline = key === 'remark';
              return (
                <Box className="three-row" key={key}>
                  <Controller
                    render={(rp) => (
                      <TextField
                        multiline={multiline}
                        name={key}
                        id="basic"
                        onChange={(e) => {
                          let currentInputItem = inputValue[key];
                          currentInputItem.value = e.target.value;
                          setValue(key, e.target.value);
                          setInputValue({
                            ...inputValue,
                            [key]: currentInputItem,
                          });
                          return rp.value;
                        }}
                        variant="standard"
                        className="input"
                        label={contentMap[key]}
                        value={rp.value ?? inputValue[key]?.value}
                      />
                    )}
                    name={key}
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label={contentMap[key]}
                  />
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    onClick={() => {
                      setInputName(key);
                      handleOpenModal();
                    }}
                  >
                    <AddIcon></AddIcon>
                    {formatMessage({ id: 'comm.action.btn.22' })}
                  </Fab>
                </Box>
              );
            })}
          <Box className="page-path">
            <Controller
              render={(rp) => (
                <TextField
                  name="pagepath"
                  control={control}
                  id="basic"
                  onChange={(e) => {
                    setFixedParam({
                      ...fixedParam,
                      miniProgram: {
                        pagepath: e.target.value,
                        appid: fixedParam?.miniProgram?.appid,
                      },
                    });
                    return rp.value;
                  }}
                  variant="standard"
                  className="input"
                  label="PagePath"
                  value={rp.value ?? fixedParam?.miniProgram?.pagepath}
                />
              )}
              name="pagepath"
              control={control}
              id="basic"
              variant="standard"
              className="input"
              label="PagePath"
            />
          </Box>
        </Box>
        <Box>
          <Box className="preview-wrapper">
            <Box>
              <Box className="preview-text">
                {formatMessage({ id: 'wechat.official.edit.n02.lbl01' })}
              </Box>
              <Box className="rectangle"></Box>
              <Box className="mobile-content">
                <Box>
                  <Box className="gap">...</Box>
                  <Box className="title">{fixedParam?.templateTitle}</Box>
                  <Box
                    className="preview-content"
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  ></Box>
                </Box>
                <Box className="mini-preview">
                  进入小程序查看
                  <ChevronRightIcon style={{ color: '#C6C6C6' }} />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="button-wrapper">
            <Button
              variant="contained"
              color="secondary"
              className="cancel"
              startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              onClick={() => {
                history.goBack();
              }}
            >
              {formatMessage({ id: 'comm.action.btn.16' })}
            </Button>

            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
              // onClick={handleSubmitData}
            >
              {formatMessage({ id: 'comm.action.btn.17' })}
            </Button>
          </Box>
        </Box>

        <ModalML
          open={openModal}
          setOpen={setOpenModal}
          onClose={() => {
            setOpenModal(false);
          }}
          title={formatMessage({ id: 'wechat.official.add.d01.lbl02' })}
          // onClose={onPeopleClose}
        >
          <ModalStyled keyField={keyField}>
            <Box className="first-line">
              <FormControl variant="standard" className="gender single-select">
                <InputLabel>
                  {formatMessage({ id: 'wechat.official.add.d01.lbl01' })}
                </InputLabel>
                <Controller
                  render={(rp) => (
                    <Select
                      value={rp.value}
                      onChange={(e) => {
                        console.log(e.target.value);
                        setKeyField(e.target.value);
                      }}
                      className="select"
                    >
                      {tempMsgVariableList?.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  placeholder={'请选择'}
                  // label="AppId"
                  name="appId"
                  variant="standard"
                  control={control}
                />
              </FormControl>
              <span className="show-data">{keyField ? keyField : '--'}</span>
            </Box>
            <Box className="button-group">
              <Button
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                {formatMessage({ id: 'comm.action.btn.08' })}
              </Button>

              <Button
                variant="contained"
                type="submit"
                className="search"
                onClick={() => {
                  let newInputValue = inputValue[inputName];
                  newInputValue.value = keyField
                    ? inputValue[inputName].value + keyField
                    : inputValue[inputName].value;

                  setInputValue({ ...inputValue, [inputName]: newInputValue });
                  setOpenModal(false);
                }}
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
              >
                {formatMessage({ id: 'comm.action.btn.07' })}
              </Button>
            </Box>
          </ModalStyled>
        </ModalML>
        <ModalML
          open={openColorModal}
          setOpen={setOpenColorModal}
          onClose={() => {
            setOpenColorModal(false);
          }}
          title={formatMessage({ id: 'wechat.official.add.d02.lbl01' })}
        >
          {/* <ModalStyled type={'colorSelect'}>
            <Box>
              <SketchPicker
                color={color}
                onChange={(e) => {
                  setColor(e.hex);
                }}
              />
            </Box>
            <Box className="button-group" mt={3}>
              <Button
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={() => {
                  setOpenColorModal(false);
                }}
              >
                {formatMessage({ id: 'comm.action.btn.08' })}
              </Button>

              <Button
                variant="contained"
                type="submit"
                className="search"
                onClick={() => {
                  let newInputValue = inputValue[inputName];
                  newInputValue.color = color;
                  setInputValue({ ...inputValue, [inputName]: newInputValue });
                  setOpenColorModal(false);
                }}
                startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
              >
                {formatMessage({ id: 'comm.action.btn.07' })}
              </Button>
            </Box>
          </ModalStyled> */}
        </ModalML>
      </AddTemplateStyled>
    </form>
  );
};
export default AddTemplate;
